"use strict";module.exports=t=>"string"==typeof t?t:t.join(" ").trim();
//# sourceMappingURL=index.js.map
